import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFull'
})
export class DateFullPipe implements PipeTransform {

  transform(value: string | Date, timeZone: string = 'America/Lima'): string {

    if (timeZone === null) {
      timeZone = 'America/Lima';
    }

    let valueReturn = '';

    if (typeof value === 'string') {
      value = new Date(value);
    }

    let options = {
      weekday: 'long',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric',
      hourCycle: 'h12',
      timeZone: timeZone
    };

    valueReturn = value.toLocaleString('es-ES', options);
    return valueReturn;
  }

}
